export enum OrderItemAction {
    APPROVE,
    APPROVE_PARTIALLY,
    PREPARING,
    PREPARED_WAITING_FOR_LOADING,
    LOADING,
    LOAD_ITEM_TO_TRUCK,
    LOADED_TO_TRUCK_FROM_WAREHOUSE,
    LOADED_TO_TRUCK_FROM_WAREHOUSE_PARTIALLY,
    SEND_BACK_FROM_WAREHOUSE,
    TAKE_BACK_FROM_WAREHOUSE,
    WAITING_FOR_OUT_OF_STOCK,
    LOAD_STATUS_ACCEPTED
}
